import type { AuthMeResponse } from '@blms/shared/schemas/shiftbook';

type AuthMode = AuthMeResponse['authMode'];

export const AUTH_MODE_STORAGE_KEY = 'blms-auth-mode';

const AUTH_MODES = new Set<AuthMode>(['dev', 'm365']);

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function getStoredAuthMode(): AuthMode | null {
  if (!canUseStorage()) {
    return null;
  }

  try {
    const value = window.localStorage.getItem(AUTH_MODE_STORAGE_KEY);
    if (!value) {
      return null;
    }

    if (AUTH_MODES.has(value as AuthMode)) {
      return value as AuthMode;
    }

    window.localStorage.removeItem(AUTH_MODE_STORAGE_KEY);
    return null;
  } catch {
    return null;
  }
}

export function setStoredAuthMode(authMode: AuthMode): void {
  if (!canUseStorage()) {
    return;
  }

  try {
    window.localStorage.setItem(AUTH_MODE_STORAGE_KEY, authMode);
  } catch {
    // Ignore storage failures in locked-down browsers.
  }
}
